const feedbackEnglish = {
  name: 'Name',
  email: 'Email',
  message: 'Message',
  send: 'Send',
  successMessage: 'Feedback sent successfully.',
  failedMessage: 'Feedback not sent successfully.',
};

const feedbackNepali = {
  name: 'नाम',
  email: 'इमेल',
  message: 'सन्देश',
  send: 'पठाउनुहोस्',
  successMessage: 'प्रतिकृया सफलतापूर्वक पठाइयाे ।',
  failedMessage: 'प्रतिकृया सफल भएन ।',
};

export { feedbackEnglish, feedbackNepali };



// WEBPACK FOOTER //
// ./src/localization/feedback.js